import { render, staticRenderFns } from "./ClampCell.vue?vue&type=template&id=f38980e4&scoped=true"
import script from "./ClampCell.vue?vue&type=script&lang=js"
export * from "./ClampCell.vue?vue&type=script&lang=js"
import style0 from "./ClampCell.vue?vue&type=style&index=0&id=f38980e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38980e4",
  null
  
)

export default component.exports